import colors from 'vuetify/lib/util/colors';

export function translateColorToHex(color, vuetify) {
    if ('string' !== typeof color || color.trim().length == 0) {
        return color;
    }
    if (color.startsWith('#') || color.startsWith('rgb')) {
        return color;
    }
    const themeColors = Object.keys(vuetify.theme.currentTheme);
    const themeColorIndex = themeColors.indexOf(color);
    if (themeColorIndex > -1) {
        return vuetify.theme.currentTheme[color];
    }
    let baseColor;
    let shade;
    if (color.includes(' ')) {
        const [bc, s] = color.split(' ');
        baseColor = bc;
        shade = s;
    }
    else {
        baseColor = color;
        shade = 'base';
    }
    const generalColors = Object.keys(colors);
    const generalColorsIndex = generalColors.indexOf(baseColor);
    const themeColorsShadeIndex = themeColors.indexOf(baseColor);
    if (generalColorsIndex > -1) {
        const fixedShade = shade.toLowerCase().replace('-', '');
        const co = colors[generalColors[generalColorsIndex]];
        return co[fixedShade];
    }
    else if (themeColorsShadeIndex > -1) {
        const fixedShade = shade.toLowerCase().replace('-', '');
        const co = vuetify.theme.parsedTheme[themeColors[themeColorsShadeIndex]]
        return co[fixedShade];
    }
    return color;
}